import parser from 'ua-parser-js';

const client = parser();

export default {
  Origin: window.location.origin, // Source/origin of the event
  URL: document.URL, // Current page URL
  Referrer: document.referrer, // Referring URL
  Browser: client.browser?.name,
  'Browser Version': client.browser?.version,
  'Operating System': client.os?.name,
  'Os Version': client.os?.version,
  'Screen Width': window.screen?.width,
  'Screen Height': window.screen?.height,
};
